export const IMG_COMPRESS_SUFFIX = "?imageMogr2/format/webp/thumbnail/700x/quality/1";
export const IMG_COMPRESS_SUFFIX_60 = "?imageMogr2/format/webp/thumbnail/1920x/quality/60";